export default function reducer(state = null) {
  return state
}
